import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';

import {
  Button, TextField, InputAdornment, Select, MenuItem,
  InputLabel, FormControl, ListSubheader
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Swal from 'sweetalert2'

import { getAllTimezones } from "countries-and-timezones"

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { colors, roles, toastTimerValue } from '../../../../Shared/utils';
import { create, checkPiceasoftInfo } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { setLocationGridValues, getRandomPassword } from '../../../../Functions/utils';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import '../../../SweetAlert.css'


export default function CreateLocation({ groups, locations, setLocations, setSelectedLocation, databV2, setDatabV2, owners }) {

  // console.log("24 - databV2=", databV2);

  const { t } = useTranslation();
  const [{user}, appDispatch] = useAppContext();
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();

  const [loading, setLoading] = useState(false);
  const [newLocation, setNewLocation] = useState({
    label: '', ip: process.env.REACT_APP_SDS_SERVER_IP, port: process.env.REACT_APP_SDS_SERVER_PORT, name: '', login: '', password: '', dbType: 1, groupId: user.groupId, owner: user.id,
    enabled: true, mceLocation: null, deactivation: null, activityPc: true, activityMobile: false, status: null
  });

  const [modalMode, setModalMode] = useState("location");
  const [showPassword, setShowPassword] = useState(false);
  const [showPiceasoftClientKey, setShowPiceasoftClientKey] = useState(false);

  const [checkPiceasoftInfoResult, setCheckPiceasoftInfoResult] = useState(undefined);
  const [checkPiceasoftInfoDetails, setCheckPiceasoftInfoDetails] = useState(undefined);

  const timeZones = getAllTimezones();

  const handleClickShowPiceasoftClientKey = () => setShowPiceasoftClientKey(!showPiceasoftClientKey);

  const handleCheckPiceasoftInfo = (id, key, showMessage) => {
    setCheckPiceasoftInfoResult(undefined);

    checkPiceasoftInfo({ id, key }).then(res => {
      // console.log("53 - res=", res);

      if (res) {
        if (res.error !== undefined) {
          if (res.error !== null && res.error !== 0) {
            setCheckPiceasoftInfoResult(res && res.error);
            setCheckPiceasoftInfoDetails(res && res.details);

            if (showMessage) {
              return toast(decodeHTMLEntities
                (
                  t(`piceasoft_api_status_code.piceasoft_api_error`)
                  + ' : "'
                  + t(`piceasoft_api_status_code.${res.error}`) + '"'
                  + (res.details !== undefined ? ' (' + res.details + ')' : ""))
                , { type: 'error' }
              );
            }
          }
          else {
            setCheckPiceasoftInfoResult(0);
            setCheckPiceasoftInfoDetails(undefined);
          }
        }
        else
          setCheckPiceasoftInfoDetails(res && res.details);
      }
    });
  }


  const handleCreateLocation = (e, location) => {
    e.preventDefault();
    setLoading(true);

    if (location.mobileProcess && location.piceasoftCheck) {
      handleCheckPiceasoftInfo(location.piceaApiId, location.piceaApiKey, true);
    }

    let databaseData = location;
    databaseData.new = (modalMode === 'database');
    create({ type: 'database', database: databaseData }).then(res => {

      if (!res.success) {
        setLoading(false);
        return toast(decodeHTMLEntities(t('admin.database.errors.' + res, { name: location.name })), { type: 'error' });
      }

      if (databaseData.new) {
        toast(decodeHTMLEntities(t('admin.database.create.success', { name: location.label })), { type: 'success' });
      }

      create({ type: 'location', location }).then(res2 => {
      setLoading(false);

        if (!res2.success) {
          return toast(decodeHTMLEntities(t('admin.locations.errors.' + res2, { name: location.label })), { type: 'error' });
        }

        const newLocations = locations.concat(setLocationGridValues(t, res2.location, groups));
      setLocations(newLocations.sort((a, b) => a.label.localeCompare(b.label)));

      setSelectedLocation(null);
        toast(decodeHTMLEntities(t('admin.locations.create.success', { name: location.label })), { type: 'success' });

        setModalMode("location");
        setDatabV2([]);

        if (!!!databaseData.new) {
          toast(decodeHTMLEntities(t('admin.locations.relink.success', { name: databaseData.label })), { type: 'success' });
        }

      appDispatch({ forceReload: true });
        eventDispatch({ groupsLocationsStatus: 'pending' });
    });
    });
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  // console.log("97 - databV2=", databV2);
  // console.log("140 - user=", user);
  // console.log("141 - newLocation=", newLocation);


  // OWNER options:
  let ownerOptions = [];
  for (const owner of owners) {
    let option = {
      id: owner.id,
      value: owner.email
    }
    ownerOptions.push(option);
  }



  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => {
        handleCreateLocation(e, newLocation);

        // if (modalMode === "location")
        //   handleCreateLocation(e, newLocation);
        // else if (modalMode === "database")
        //   handleCreateDatabase(e, newLocation);
        console.log("91 - e=", e);

      }}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.locations.create.title')}</h1>
            {user.roleId <= roles.stAdmin && <div>
              <select
                required
                className="singleSelect"
                value={newLocation.groupId}
                title={t('admin.locations.columns.group')}
                onChange={e => setNewLocation({ ...newLocation, groupId: Number(e.target.value) })}
              >
                <option value="" hidden>{t('admin.locations.create.no_group')}</option>
                {groups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
              </select>
            </div>
            }
          </div>

          <div className="prompt__content">
            <div className="flexRow" style={{ alignItems: 'flex-end' }}>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">description</span>
                  </InputAdornment>
                }}
                required
                variant="outlined"
                style={{ width: '75%' }}
                value={newLocation.label}
                label={t('admin.locations.columns.label')}
                onChange={e => setNewLocation({ ...newLocation, label: e.target.value })}
              />

              <div style={{ width: '25%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.db_type')}</InputLabel>
                  <Select
                    label={t('admin.locations.columns.db_type')} value={newLocation.dbType}
                    onChange={e => setNewLocation({ ...newLocation, dbType: e.target.value })}
                  >
                    <MenuItem value={1}>SDS</MenuItem>
                    <MenuItem value={2}>Kiosk</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>


            <div className="flexRow">
              <div style={{ width: '50%' }}>
                <FormControl
                  variant="outlined"
                  style={{ width: '100%' }}
                  required
                // disabled
                >
                  {(modalMode === "location") && (
                    <>
                  <InputLabel>{t('admin.locations.columns.name')}</InputLabel>
                  <Select
                    label={t('admin.locations.columns.name')}
                    value={newLocation.name}
                    onChange={e => {
                          // console.log("131 - change e=", e);
                          if (e.target.value === "FAKE_createDatabaseOption") {
                            setNewLocation({ ...newLocation, name: "", login: "", password: getRandomPassword() });
                            setModalMode("database");
                          }
                          else {
                            const strTmp = e.target.value.replaceAll(/[^a-zA-Z0-9\d]/g, '_');
                            setNewLocation({ ...newLocation, name: e.target.value, login: strTmp + '_SDS_User', password: getRandomPassword() });
                          }
                    }}
                  >                  

                        <MenuItem
                          value="FAKE_createDatabaseOption" >
                          <span
                            className="material-icons-outlined"
                            style={{
                              textAlign: 'left',
                              width: '8%',
                              //fontSize: '16px',
                              color: colors.softthinks
                            }}>
                            add_circle_outline
                          </span>

                          <span
                            style={{
                              padding: '0 16px',
                              width: "92%",
                              maxWidth: "100%",
                              textAlign: 'left',
                              fontSize: '18px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                              transition: '0.25s',
                              // color: 'grey'
                              color: colors.softthinks
                            }}>
                            {t('admin.locations.create.create_database')}
                          </span>
                        </MenuItem>

                        <MenuItem value="choose" style={{ display: 'none' }}>
                          {''}
                        </MenuItem>

                    {(databV2.length > 0) ? (
                          databV2.map(bdd => {

                            if (bdd.id !== "FAKE_EmptyData")
                              return (
                                <MenuItem
                                  key={bdd.id}
                                  value={bdd.name}>
                                  {bdd.name}
                                </MenuItem>
                              )
                            else
                              return <></>
                          })
                    ) : (
                      <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                        <BeatLoader color={colors.softthinks} />
                      </div>
                    )}
                  </Select>
                    </>
                  )}

                  {(modalMode === "database") && (
                    <TextField
                      // InputProps={{
                      //   startAdornment: <InputAdornment position="start">
                      //     <span className="material-icons-outlined">storage</span>
                      //   </InputAdornment>
                      // }}
                      required
                      variant="outlined"
                      style={{ width: '100%' }}
                      value={newLocation.name}
                      label={t('admin.locations.create.newname')}
                      onChange={e => {
                        const strTmp = e.target.value.replaceAll(/[^a-zA-Z0-9\d]/g, '_');
                        setNewLocation({ ...newLocation, name: strTmp, login: strTmp !== "" ? strTmp + '_SDS_User' : "" })
                      }}
                    />
                  )}
                </FormControl>
              </div>

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">cloud</span>
                  </InputAdornment>,
                  endAdornment: <>
                    <span className="separation" style={{ margin: '12px', alignSelf: 'stretch' }} />
                    <input type="numeric" min="0" max="99999" placeholder="N/A" value={newLocation.port}
                      onChange={e => setNewLocation({ ...newLocation, port: e.target.value.slice(0, 5) })}
                    />
                  </>
                }}
                placeholder="N/A"
                variant="outlined"
                className="loc__port"
                value={newLocation.ip}
                onChange={e => setNewLocation({ ...newLocation, ip: e.target.value })}
                label={t('admin.locations.columns.ip') + ' | ' + t('admin.locations.columns.port')}
              />
            </div>

            <div className="flexRow">
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">account_circle</span>
                  </InputAdornment>,
                  // readOnly: (modalMode === "database") ? true : false
                  readOnly: true
                }}
                placeholder="N/A"
                //required
                disabled
                variant="outlined"
                autoComplete="off"
                label={t('login.field1')}
                value={newLocation.login}
                onChange={e => setNewLocation({ ...newLocation, login: e.target.value })}
              />

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined"
                    // onClick={e => {
                    //   console.log("285 - e=", e);
                    //   return handleClickShowPassword()
                    // }}
                    >
                      lock
                    </span>
                  </InputAdornment>,
                  readOnly: true
                }}
                //type={!showPassword ? "password" : " "}
                placeholder="N/A"
                // required
                disabled
                variant="outlined"
                autoComplete="off"
                name="loc-password"
                label={t('login.field2')}
                value={newLocation.password}
                onChange={e => setNewLocation({ ...newLocation, password: e.target.value })}
              />
            </div>


            <div className="flexRow">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  value={newLocation.deactivation}
                  InputAdornmentProps={{ position: 'start' }}
                  label={t('admin.locations.columns.deactivation')}
                  onChange={date => setNewLocation({
                    ...newLocation, // set date to null when date is cleared
                    deactivation: new Date(date).getTime() ? new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)).toJSON().slice(0, 10) : null
                  })}
                  format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                  placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}
                  style={{ width: '100%' }}
                />
              </MuiPickersUtilsProvider>

              <div style={{ width: '100%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.status')}</InputLabel>
                  <Select                    
                    value={newLocation.status}
                    label={t('admin.locations.columns.status')}
                    onChange={e => setNewLocation({ ...newLocation, status: e.target.value })}
                  >
                    <MenuItem value={'production'}>{t('admin.locations.status.production')}</MenuItem>
                    <MenuItem value={'pilot'}>{t('admin.locations.status.pilot')}</MenuItem>
                    <MenuItem value={'internal'}>{t('admin.locations.status.internal')}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              <FormControl variant="outlined" style={{ width: '66%' }}>
                <InputLabel>{t('admin.locations.columns.timezone')}</InputLabel>
                <Select
                  value={newLocation.timezone}
                  label={t('admin.locations.columns.timezone')}
                  onChange={e => setNewLocation({ ...newLocation, timezone: e.target.value })}
                >

                  {Object.entries(timeZones).sort(function (a, b) {
                    if (a[1].utcOffset < b[1].utcOffset) {
                      return -1;
                    }
                    if (a[1].utcOffset > b[1].utcOffset) {
                      return 1;
                    }
                    return 0;
                  }).map(tz => {
                    return (
                      <MenuItem
                        key={tz[1].name}
                        value={tz[1].name}
                      >
                        {"(GMT"+ tz[1].utcOffsetStr + ")  " + tz[1].name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>

              <div style={{ width: '33%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.creator')}</InputLabel>
                  <Select
                    label={t('admin.locations.columns.creator')} value={newLocation.owner}
                    onChange={e => setNewLocation({ ...newLocation, owner: e.target.value })}
                  >
                    {ownerOptions.map(owner => <MenuItem value={owner.id}>{owner.value}</MenuItem>)}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* mobileProcess */}
            <div className="checkbox action">
              <input
                disabled={false}
                id="mobileProcess"
                type="checkbox"
                defaultChecked={newLocation.mobileProcess}
                onChange={e => {
                  setNewLocation({ ...newLocation, mobileProcess: !newLocation.mobileProcess })
                }}
              />
              <label htmlFor="mobileProcessing">{t('admin.locations.create.mobileProcessing')}</label>
            </div>

            {newLocation.mobileProcess && (
              <div className="checkbox action">
                <input
                  disabled={false}
                  id="mobileProcess"
                  type="checkbox"
                  defaultChecked={newLocation.piceasoftCheck}
                  onChange={e => {
                    setNewLocation({ ...newLocation, piceasoftCheck: !newLocation.piceasoftCheck })
                  }}
                />
                <label htmlFor="piceasoftCheck">{t('admin.locations.create.piceasoftCheck')}</label>

                <span style={{ paddingLeft: '180px' }}>
                  <Button
                    className="button"
                    onClick={() => handleCheckPiceasoftInfo(newLocation.piceaApiId, newLocation.piceaApiKey, false)}
                    title={
                      (checkPiceasoftInfoResult !== undefined && checkPiceasoftInfoResult !== 0) ? (
                        t(`piceasoft_api_status_code.piceasoft_api_error`)
                        + ' : "'
                        + t(`piceasoft_api_status_code.${checkPiceasoftInfoResult}`) + '"'
                        + (checkPiceasoftInfoDetails !== undefined ? ' (' + checkPiceasoftInfoDetails + ')' : "")) : t('admin.locations.create.check_connection')
                    }
                    style={{ color: (checkPiceasoftInfoResult === undefined ? 'gray' : (checkPiceasoftInfoResult !== 0 ? "Red" : "Green")) }}
                  >
                    <span
                      className="material-icons-round"
                      style={{ color: (checkPiceasoftInfoResult === undefined ? 'gray' : (checkPiceasoftInfoResult !== 0 ? "Red" : "Green")) }}
                    >
                      check_circle_outlined
                    </span>
                    {t('admin.locations.create.check_connection')}
                  </Button>
                </span>
              </div>
            )}

            {newLocation.mobileProcess && newLocation.piceasoftCheck && (
              <TextField
                InputProps={{}}
                placeholder="N/A"
                variant="outlined"
                label={t('admin.locations.create.piceasoftClientId')}
                value={newLocation.piceaApiId}
                onChange={e => setNewLocation({ ...newLocation, piceaApiId: e.target.value })}
              />
            )}

            {newLocation.mobileProcess && newLocation.piceasoftCheck && (
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined" onClick={e => {
                      if (user.roleId <= roles.stAdmin)
                        return handleClickShowPiceasoftClientKey()
                    }}>
                      lock
                    </span>
                  </InputAdornment>
                }}
                type={(!showPiceasoftClientKey) ? "password" : " "}
                placeholder="N/A"
                // required
                //disabled={newLocation.piceasoftCheck}
                variant="outlined"
                autoComplete="off"
                name="piceasoft-clientkey"
                label={t('admin.locations.create.piceasoftClientKey')}
                value={newLocation.piceaApiKey}
                onChange={e => setNewLocation({ ...newLocation, piceaApiKey: e.target.value })}
              />
            )}
          </div>

        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => {
            if (modalMode === "location")
              setSelectedLocation(null);
            else if (modalMode === "database")
              setModalMode("location");
          }}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.create')}
          </Button>
        </PromptActions>
      </form>

    </Prompt>
  );
}
